<div class="history" *ngIf="messages">
  <app-chat-bubble
    *ngFor="let m of messages"
    [message]="m"
  ></app-chat-bubble>
</div>
